import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import { DecisionNode } from 'lib/types/models';
import { CompanyComitee } from 'lib/types/models';
import {
  CategorizedNodes,
  NEW_NODE,
  Node,
} from 'pages/Settings/Components/Risk/Components/DecisionEngines/components/Create/types';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import RangesAssign from './RangesAssignation';

type Props = {
  newNode: Node;
  setNewNode: (node: Node) => void;
  openAddNode: boolean;
  setOpenAddNode: (open: boolean) => void;
  decisionNodes: DecisionNode[];
  decisionNodesAssignation: Node[];
  setDecisionNodesAssignation: (nodes: Node[]) => void;
  comiteesAvailables: CompanyComitee[];
  categorizedNodes: CategorizedNodes;
};

const NewMatrixAssignation = (props: Props) => {
  const {
    setDecisionNodesAssignation,
    decisionNodesAssignation,
    decisionNodes,
    categorizedNodes,
    openAddNode,
    setOpenAddNode,
    newNode,
    setNewNode,
  } = props;
  const [selectedCategory, setSelectedCategory] = useState('');
  const [counter, setCounter] = useState(
    decisionNodesAssignation.length
      ? decisionNodesAssignation[decisionNodesAssignation.length - 1].id + 1
      : 1,
  );
  const { id } = useParams();
  const [operation, setOperation] = useState('gt');

  const validateRanges = () => {
    if (newNode.ranges.length < 2) {
      return alert('Debes agregar al menos dos rangos');
    }
    const ranges = newNode.ranges;
    for (let i = 0; i < ranges.length; i++) {
      if (ranges[i].decisionNodeId === undefined || ranges[i].value === null) {
        if (i === ranges.length - 1) return true;
        return alert('Debes completar todos los rangos');
      }
    }
    return true;
  };
  const addNode = () => {
    if (selectedCategory !== 'decisionEngine') {
      if (!validateRanges()) return;
    }
    if (newNode.originNodeId === null) {
      return alert('Debes completar todos los camposa');
    }
    const nodes = [...decisionNodesAssignation];
    nodes.push({ ...newNode });
    const nextCounter = counter;
    setCounter(nextCounter + 1);
    setDecisionNodesAssignation(nodes);
    setOpenAddNode(false);
    setNewNode(NEW_NODE);
  };

  const addRange = () => {
    const range = {
      value: '',
      decisionNodeId: newNode.id,
    };
    setNewNode({ ...newNode, ranges: [...newNode.ranges, range] });
  };

  const setUpRangeForBoolean = () => {
    const ranges = [
      {
        value: '0',
        decisionNodeId: newNode.id,
        nodeId: 0,
      },
      {
        value: '1',
        decisionNodeId: newNode.id,
        nodeId: 1,
      },
    ];
    return ranges;
  };

  const handleChangeRange = (e: SelectChangeEvent<number>, index: number) => {
    const { value } = e.target;
    const { name } = e.target;
    const ranges = newNode.ranges.map((x, i) => {
      if (i === index) return { ...x, [name]: value };
      return x;
    });
    setNewNode({ ...newNode, ranges });
  };

  const handleChangeOrigin = (e: SelectChangeEvent<number | null>) => {
    const { value } = e.target;
    const { name } = e.target;
    if (name === 'originNodeId') {
      const node = decisionNodes.find((x) => x.id === Number(value));

      return setNewNode({
        ...newNode,
        [String(name)]: value,
        value: '',
        type: node?.type || null,
        operation: node?.operation || 'gt',
        description: node?.description || '',
        name: node?.name || '',
        id: counter,
        ranges: node?.type === 'boolean' ? setUpRangeForBoolean() : [],
      });
    }
    setNewNode({ ...newNode, [name]: value });
  };

  const handleChangeCategory = (e: SelectChangeEvent<string>) => {
    setSelectedCategory(e.target.value);
  };

  const deleteRange = (index: number) => {
    const ranges = newNode.ranges.filter((x, i) => i !== index);
    ranges[ranges.length - 1].max = null;
    setNewNode({ ...newNode, ranges });
  };

  const availableNodeForSelection = () => {
    const selectedIds = decisionNodesAssignation.map((x) => x.originNodeId);
    return decisionNodes.filter(
      (x) =>
        x.type !== 'final' &&
        !selectedIds.includes(x.id) &&
        x.category === selectedCategory &&
        Number(x.subDecisionEngineId) !== Number(id),
    );
  };
  const availableFinalNodeForSelection = () => {
    return decisionNodes.filter((x) => x.type === 'final');
  };

  return (
    <Dialog
      maxWidth="md"
      open={openAddNode}
      onClose={() => setOpenAddNode(false)}
    >
      <DialogTitle>Agregar evaluación</DialogTitle>
      <DialogContent style={{ width: '500px' }}>
        <Typography variant="body1" gutterBottom>
          Acá podrás definir una nueva evaluación dentro de la matriz.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <b>Evaluación a agregar</b>
        </Typography>
        <div style={{ padding: '10px 0px' }}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="filter-label">Categorías</InputLabel>
            <Select
              labelId="filter-label"
              value={selectedCategory}
              onChange={handleChangeCategory}
              label="Categorías"
            >
              {Object.keys(categorizedNodes).map((x, index) => (
                <MenuItem key={index} value={x}>
                  {x}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ padding: '10px 0px' }}>
          <FormControl
            fullWidth
            variant="outlined"
            disabled={selectedCategory === ''}
          >
            <InputLabel id="filter-label">Evaluaciones disponibles</InputLabel>
            <Select
              labelId="filter-label"
              id="Filtrar por estado"
              name="originNodeId"
              value={newNode.originNodeId}
              onChange={handleChangeOrigin}
              label="Evaluaciones disponibles"
            >
              {availableNodeForSelection().map((x, index) => (
                <MenuItem key={index} value={x.id}>
                  {x.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {newNode.originNodeId && (
          <div style={{ padding: '20ox' }}>
            <Typography variant="body1" gutterBottom>
              {newNode.description}
            </Typography>
          </div>
        )}
        {newNode.type !== 'decisionEngine' && newNode.originNodeId && (
          <RangesAssign
            newNode={newNode}
            setNewNode={setNewNode}
            addRange={addRange}
            handleChangeRange={handleChangeRange}
            deleteRange={deleteRange}
            availableFinalNodeForSelection={availableFinalNodeForSelection}
            operation={operation}
            setOperation={setOperation}
          />
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={() => setOpenAddNode(false)}
          color="secondary"
          variant="contained"
        >
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={() => addNode()}
          color="primary"
          variant="contained"
        >
          Agregar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NewMatrixAssignation;
